import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from './EvolutionarySection.module.scss';
import pointImage from '../../../assets/images/manos-flor-final.png';

export const EvolutionarySection: React.FC = () => {
  const { t } = useTranslation();

  return (
    <section className={styles['section-open']} id="punto-de-partida">
      <div className={styles['point-section']}>
        
        <div className={styles['point-content']}>
          <p className={styles['eyebrow']}>
            {t('landing.evolutionary.eyebrow', 'Punto de partida')}
          </p>
          <h2 className={styles['section-title']}>
            {t('landing.evolutionary.title', 'Acompañar con propósito no siempre significa hacerlo en comunidad')}
          </h2>
          <p className={styles['section-copy']}>
            {t('landing.evolutionary.para1', 'Hoy existen muchos profesionales valiosos, con formación, sensibilidad y mucho para aportar, que acompañan procesos importantes desde una mirada humana e integrativa. Pero muchas veces lo hacen de forma bastante aislada, con poco intercambio, poca red y pocas oportunidades de construir en conjunto con otros colegas.')}
          </p>
          <p className={styles['quote']}>
            {t('landing.evolutionary.quote', 'Bodhiwell nace también para responder a esa realidad.')}
          </p>
        </div>

        <figure className={styles['point-figure']}>
          <img 
            src={pointImage} 
            alt={t('landing.evolutionary.imageAlt', 'Manos sosteniendo una flor luminosa')} 
          />
        </figure>

      </div>
    </section>
  );
};